import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import type { CustomerDistributionItem } from '@/src/types/admin/analytics'

const COLORS = [
  'hsl(var(--primary))',
  '#06b6d4',
  '#8b5cf6',
  '#f59e0b',
  '#10b981',
  '#ef4444',
]

interface CustomerDonutChartProps {
  data: CustomerDistributionItem[]
  height?: number
}

export function CustomerDonutChart({ data, height = 280 }: CustomerDonutChartProps) {
  const total = data.reduce((sum, d) => sum + d.customer_count, 0)

  return (
    <ResponsiveContainer width="100%" height={height}>
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius="55%"
          outerRadius="75%"
          paddingAngle={2}
          dataKey="customer_count"
          nameKey="package_code"
          label={({ package_code, percent }) =>
            `${package_code} ${(percent * 100).toFixed(0)}%`
          }
          labelLine={false}
        >
          {data.map((_, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          formatter={(value: number, name: string) => [
            `${value.toLocaleString()} คน (${total > 0 ? ((value / total) * 100).toFixed(1) : 0}%)`,
            name,
          ]}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  )
}
